import { get } from 'lodash';
import Api from 'client/api/v2/Api';
import BoundItemsApi from 'client/api/v2/BoundItemsApi';
import axios from 'axios';

class CommandRunnerBoundItemsApi extends BoundItemsApi {
  /**
  * Override initialize method so we can get the list of command runner ids
  * from the commandRunner array returned on GET /api/commands/<id>
  *
  * Remove when the associations endpoint is modified to allow binding commands to users
  */
  initialize(baseUrl) {
    const api = new Api();

    const params = {
      skip: 0,
      limit: this.maxFetchLimit,
    };

    return api.initialize()
      .then(() => axios.get(`${baseUrl}?${this.param(params)}`))
      .then((resp) => {
        const commandRunners = get(resp, 'data.commandRunners', []);
        return {
          results: commandRunners.map(commandRunner => ({ id: commandRunner })),
          totalCount: commandRunners.length,
        };
      });
  }
}

export default new CommandRunnerBoundItemsApi();
